import _ from 'lodash';
import isObject from './isObject.js';
import diffValue from './main.js';

export default function diffArray(baseline, array, options = {}) {
  const refItem = _.head(array) || _.head(baseline);

  if (isObject(refItem)) {
    const diff = [];
    const identityKey = getIdentityKey(refItem);

    if (!identityKey || _.some(array, item => !getIdentityKey(item))) {
      return _.isEqual(array, baseline) ? null : array;
    }

    let firstTrailingNewItemIndex = array.length;

    for (let i = array.length - 1; i >= 0; i--) {
      if (_.some(baseline, { [identityKey]: array[i][identityKey] })) {
        break;
      } else {
        firstTrailingNewItemIndex = i;
      }
    }

    _.forEach(array, (item, index) => {
      const predicate = { [identityKey]: item[identityKey] };
      const baselineItemIndex = _.findIndex(baseline, predicate);
      const baselineItem = baselineItemIndex === -1 ? undefined : baseline[baselineItemIndex];

      const needIndexing = baselineItem
        ? index !== baselineItemIndex
        : index < firstTrailingNewItemIndex;

      const itemDiff = diffValue(baselineItem, item, options);
      const indexDiff = needIndexing ? { $index: index } : undefined;

      if (itemDiff || indexDiff) {
        diff.push({ ...predicate, ...itemDiff, ...indexDiff });
      }
    });

    _.forEach(baseline, item => {
      if (_.has(item, identityKey)) {
        const predicate = { [identityKey]: item[identityKey] };
        if (!_.find(array, predicate)) {
          diff.push({ ...predicate, $remove: true });
        }
      } else {
        const itemIdentityKey = getIdentityKey(item);
        if (!itemIdentityKey) return;
        diff.push({ [itemIdentityKey]: item[itemIdentityKey], $remove: true });
      }
    });

    return _.isEmpty(diff) ? null : diff;
  }

  if (_.isArray(_.head(array)) && !_.isEmpty(_.head(array))) {
    const fn = (item, index) => diffValue(_.get(baseline, index), item, options);
    const diff = _.compact(_.map(array, fn));
    return _.isEmpty(diff) ? null : diff;
  }

  if (_.size(array) !== _.size(baseline) || _.difference(array, baseline).length > 0) {
    return array;
  }

  return null;
}

const getIdentityKey = obj => _.find(['id', 'key', 'name'], key => _.has(obj, key));
